import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { guaranteeItems } from '../../data/landing';
export function Guarantee() {
  return <section className="bg-cream" data-id="element-189" data-mp="24mommw1f3ih5">
      <div className="mx-auto max-w-3xl px-5 py-14 md:py-20" data-id="element-190" data-mp="24lncquw51210">
        <div className="rounded-3xl border-2 border-teal bg-white p-6 text-center sm:p-10" data-id="element-191" data-mp="29egct5gnvm6r">
          <span className="mx-auto grid h-24 w-24 place-items-center rounded-full bg-teal text-white shadow-lg shadow-teal/30" data-id="element-192" data-mp="2edj9a1iksk34">
            <ShieldCheckIcon className="h-12 w-12" aria-hidden="true" data-id="element-193" data-mp="2jat7a5k1642k" />
          </span>
          <h2 className="mt-5 font-display text-[32px] font-bold leading-tight text-navy sm:text-[44px]" data-id="element-194" data-mp="2oc8ua35rqknl">
            My <em className="text-teal-dark" data-id="element-195" data-mp="2sbhnn6wwcgim">7-Day</em> Guarantee
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-196" data-mp="txy4nshcnmgr">
            I don't want you to buy another digital product that ends up sitting unopened on your phone. That's why I'm giving you 7 days to explore everything. You can:
          </p>

          <ul className="mx-auto mt-6 grid max-w-xl gap-2 text-left sm:grid-cols-2" data-id="element-197" data-mp="3sn9fou183t5v">
            {guaranteeItems.map(g => <li key={g} className="flex items-center gap-3 rounded-xl bg-teal-soft px-4 py-3 text-[16px] font-bold text-navy" data-id="element-198" data-mp="3iv3ohmispfrq">
                <CheckIcon className="h-5 w-5 shrink-0 text-teal-dark" strokeWidth={3} aria-hidden="true" data-id="element-199" data-mp="3dy3ljkh8st4u" />
                {g}
              </li>)}
          </ul>

          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-navy" data-id="element-200" data-mp="afk3fasa33nr">
            And if you decide that Calm Response 5™ isn't right for you, you can request a refund according to the purchase terms.
          </p>
        </div>

        <div className="mt-10" data-id="element-201" data-mp="hdyslf37jf7">
          <CTAButton label="Try Calm Response 5™ risk-free" data-id="element-202" data-mp="2q6ptlfn06zke" />
        </div>
      </div>
    </section>;
}